const cafe = {
    default: {
        host: "https://id.es6.vn",
    },
    google: {
        domain: "https://www.google.com",
        search: {
            path: "/search",
        },
    },
    format: "0,0",
};
const df = cafe.default;
const gg = cafe.google;
const numeral = require("numeral");
const formatNumber = (obj) => {
    let number = 0;
    let format = cafe.format;
    if (typeof (obj) === "object") {
        number = obj.number;
        format = obj.format || cafe.format;
    };
    if (!isNaN(obj)) number = obj;
    return isNaN(number) ? "isNaN" : numeral(number).format(format);
};
const formatCurrency = ({ number = 0, currency = "đ" }) => isNaN(number) ? "isNaN" : `${numeral(number).format(cafe.format)} ${currency}`;
const formatK = (number) => isNaN(number) ? "isNaN" : `${numeral(number / 1000).format(cafe.format)}k`;

const removeRegularExpression = (text) => {
    text = text || "";
    return text.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1")
};

const removeDiacritics = (text) => {
    if (typeof (text) !== "string") return null;
    let tResult = text.toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d").replace(/[^\w]/gi, "-");
    while (tResult.includes("--")) tResult = tResult.replace(/--/g, "-");
    let k = tResult.lastIndexOf("-");
    if (k === tResult.length - 1) tResult = tResult.substring(0, k);

    return tResult;
};

const base64 = {
    encode: (input) => {
        let output = Buffer.from(input).toString("base64");
        return output;
    },
    decode: (input) => {
        let output = Buffer.from(input, "base64").toString("utf-8");
        return output;
    },
};

const validateHref = ({ field = "tên miền", value }) => {
    if (!value) return `Bạn cần nhập ${field}!`;
    let reg = new RegExp(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g);
    return reg.test(value) || `${field} không hợp lệ!`;
};

const validateEmail = (text) => {
    if (!text) return "Bạn cần nhập email!";
    let reg = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/g);
    return reg.test(text) || "Email không hợp lệ!";
};

const validateFullName = (text) => {
    if (!text) return "FullName is required!";
    if (text.length < 5 || text.length > 50) return "Họ tên có độ dài phải lớn hơn 5 vào nhỏ hơn 50!";
    return true;
};

const validateContent = (text) => {
    if (!text) return "Content is required!";
    if (text.length < 10) return "Nội dung quá ngắn!";
    return true;
};

const validatePhoneNumber = (value) => {
    if (!value) return "Bạn chưa nhập số điện thoại!";
    if (isNaN(value)) return "Điện thoại chỉ nhập số!";
    if (value.length !== 10 && value.length !== 11) return "Số điện thoại không hợp lệ!";
    return true;
};

const validateText = ({ field = "thông tin", value }) => {
    let valueType = typeof (value);
    if (valueType === "number") return true;
    if (valueType !== "string" || !value.length) return `Bạn cần nhập ${field}!`;
    return true;
};

const validateNumber = ({ min = null, max = null, field = "thông tin", value }) => {
    let valueType = typeof (value);
    let isInValid =
        valueType === "null"
        || valueType === "undefined"
        || (valueType === "string" && !value)
        || isNaN(value)
    if (isInValid) return `${field} phải là số!`;
    if (typeof (min) === "number" && value < min) return `${field} tối thiểu là ${min}!`;
    if (typeof (max) === "number" && value > max) return `${field} tối đa là ${max}!`;
    return true;
};

const validatePercentage = ({ field, value }) => {
    return validateNumber({ min: 1, max: 100, field, value });
};

const randomNumber = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

const randomString = (max) => {
    let possible = {
        text: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        number: "0123456789",
    };
    let possible_string = `${possible.text}${possible.number}`;
    let x = randomNumber(0, possible.text.length - 1);
    let text = possible.text.charAt(x);
    for (let i = 1; i < max; i++) {
        x = randomNumber(0, possible_string.length - 1);
        text += possible_string.charAt(x);
    };

    return text;
};

const toUpperFirstLetter = (text) => {
    if (!text) return null;
    return `${text[0].toUpperCase()}${text.slice(1).toLowerCase()}`;
};

const toUpperFirstLetterOfWord = (text) => {
    if (!text) return null;
    let arr = text.split(" ");
    let words = [];
    for (let letter of arr) {
        if (!letter.trim()) continue;
        words.push(toUpperFirstLetter(letter));
        //`${letter[0].toUpperCase()}${letter.slice(1).toLowerCase()}`
    };
    return words.join(" ");
};

const linkGoogleSearch = (keyword) => {
    if (!keyword) return gg.domain;
    let href = `${gg.domain}${gg.search.path}?q=${keyword}&sourceid=chrome&ie=UTF-8`;

    return href;
};

const mapImgSrc = (src) => {
    if (!src) return null;
    let x = src.indexOf("http");
    let y = src.indexOf("data:image");
    if (x !== 0 && y !== 0) return `${df.host}${src}`;

    return src;
};

export const getHost = (href) => {
    if (!href) return null;
    let url = new URL(href);
    let hn = url.hostname.replace("www.", "");

    return hn;
};

export const cpo = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};

export const map = {
    imgSrc: mapImgSrc,
};

export const validate = {
    href: validateHref,
    email: validateEmail,
    fullName: validateFullName,
    phoneNumber: validatePhoneNumber,
    content: validateContent,
    text: validateText,
    number: validateNumber,
    percentage: validatePercentage,
};

export { base64 };

export const format = {
    k: formatK,
    number: formatNumber,
    currency: formatCurrency,
};

export const remove = {
    reg: removeRegularExpression,
    diacritics: removeDiacritics,
};

export const random = {
    number: randomNumber,
    string: randomString,
};

export const to = {
    upper: {
        firstLetter: toUpperFirstLetter,
        firstLetterOfWord: toUpperFirstLetterOfWord,
    },
};

export const link = {
    google: {
        search: linkGoogleSearch,
    },
};


// WEBPACK FOOTER //
// src/utils/helpers/helper.text.js